module.exports = __webpack_public_path__ + "static/001-7ce0ef014488a0820f70338023f5b2b4.png";